// extracted by mini-css-extract-plugin
export var layoutHeader = "layout-module--layoutHeader--3tkeb";
export var layoutFooter = "layout-module--layoutFooter--13fU_";
export var layoutMain = "layout-module--layoutMain--1KIaU";
export var featuredImage = "layout-module--featuredImage--19TMv";
export var grid = "layout-module--grid--1RCXO";